import { Box, CircularProgress, Skeleton } from "@mui/material";
import React from "react";
import { colors } from "../../common/pallette/colors";

const ReportSkeleton = (props:any) => {
    
    return (
        <Box sx={{ width:'100%', height:'100%', backgroundColor: colors.grey.bright, overflow: "hidden", padding: '20px'}}>
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="rectangular"width={'100%'} height={'200px'} />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="rectangular"width={'100%'} height={'200px'} />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="rectangular"width={'100%'} height={'200px'} />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="rectangular"width={'100%'} height={'200px'} />
        </Box>
        // <Skeleton variant="rectangular" width={'100%'} height={'100%'} animation={'wave'}/>
    );
}

export default ReportSkeleton;